import axios from "../../../../api/axios";

import { EntityBranchDetails } from "../types/entityBranches.types";

export const getEntityBranchById = async (branchId: string): Promise<EntityBranchDetails> => {
  const response = await axios.get(`/football-entity-branches/${branchId}`);
  return response.data.data;
};
